import BttfAxios from "@features/utils/axios";
import axios, { AxiosResponse } from "axios";
import PitchMockService from "@mocks/Pitch.mock.service";
import { IPitch } from "@appInterfaces/pitch.interfaces";
import { mockServerResponse } from "@mocks/mockServerResponse";

export type Pitch = {
  id: number;
  slug: string;
  title?: string;
  image: string;
  time_remaining: number;
  specialisation_type: string;
  pitch_date: string;
  number_of_investors: number;
  raised_percent: string;
  raised_amount: string;
  expected_amount: number;
};

class PitchesClass {
  private config = { headers: { "Cache-Control": "no-cache" } };

  public getPitch(pitchIds: number | number[]): Promise<AxiosResponse<IPitch>> {
    return BttfAxios.get(`/api/pitches?id=${pitchIds}`, () =>
      mockServerResponse(PitchMockService.getPitches()).then((resp) => resp)
    );
  }

  public getPitches(): Promise<AxiosResponse<Pitch[]>> {
    return axios.get("/api/pitches", this.config);
  }
}
const PitchesService = new PitchesClass();

export default PitchesService;
